import React, { forwardRef, useState } from 'react';
import { cn } from '../../lib/cn';

export interface LedgerInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Renders a Show/Hide toggle and forces password masking until revealed. */
  revealToggle?: boolean;
  /** Pair with LedgerField's error — set invalid={Boolean(error)} so the border and message never drift apart. */
  invalid?: boolean;
}

export const LedgerInput = forwardRef<HTMLInputElement, LedgerInputProps>(
  ({ revealToggle, invalid, type = 'text', className, disabled, ...rest }, ref) => {
    const [revealed, setRevealed] = useState(false);
    const input = (
      <input
        ref={ref}
        type={revealToggle ? (revealed ? 'text' : 'password') : type}
        aria-invalid={invalid || undefined}
        disabled={disabled}
        className={cn(
          'w-full border-b bg-transparent py-1 text-scale-1 text-ink outline-none placeholder:text-ink-muted/60',
          invalid ? 'border-sev-critical' : 'border-rule-faint focus:border-accent',
          revealToggle && 'pr-14',
          className,
        )}
        {...rest}
      />
    );
    if (!revealToggle) return input;
    return (
      <span className="relative block">
        {input}
        <button
          type="button"
          disabled={disabled}
          onClick={() => setRevealed((current) => !current)}
          className="cap-label absolute inset-y-0 right-0 cursor-pointer hover:!text-ink disabled:cursor-default"
        >
          {revealed ? 'Hide' : 'Show'}
        </button>
      </span>
    );
  },
);
LedgerInput.displayName = 'LedgerInput';
